
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import FileUploader from '@/components/FileUploader.vue';
    import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import {
        ContactInfoViewModel,
        CountryLightModel, ResultError,
    } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import Files from "@/components/Files.vue";
    import PersonMainInfo from "@/features/personProfile/views/PersonMainInfo.vue";
    import PersonFiles from "@/features/personProfile/views/PersonFiles.vue";
    import {isNullOrWhiteSpace} from "@/extensions/string.helpers";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import InAds from '@/components/InAds.vue';
    import PopoverInfo from '@/components/PopoverInfo.vue';
import { ls } from '@/CultureService';
    
    @Component({
        components: {
            Files,
            FileUploader,
            HeadingGroup,
            LabelOptional,
            PersonFiles,
            PersonMainInfo,
            SectionPageHeading,
            InAds,
            PopoverInfo
        },
    })
    export default class ContactInfo extends Vue {
        @Prop({default:ls.PersonProfile_ContactInfo_Button_SaveContactDetails})
        submitText!: string;
        @Prop({default: true})
        showTitle!: boolean;
        @Prop({required: true})
        validationErrors!: ResultError;
        @Prop({required: true})
        model!: ContactInfoViewModel;
        @Prop({required: true})
        countries!: CountryLightModel[];
        @Prop({required: true})
        canUpdate!: boolean;
        
        inAddress!: any;
       
        get ForceAddressExpansion() {
            try{

                return (Object.keys(this.validationErrors.messages).find(key => key.includes('address')) !== undefined)
                || this.model.address.countryOfResidence.length > 0 && this.model.address.countryOfResidence !== 'EE';
            }
            catch
            {
                return false;
            }
        }
        
        async save() {
            this.$emit("contact-info-saved");
        }

        get fullAddress(){
            const flat = `${(isNullOrWhiteSpace(this.model.address.flatNumber) ? `` : `- ${this.model.address.flatNumber}`)}`;
            const district = isNullOrWhiteSpace(this.model.address.district) ? `` : `, ${this.model.address.district}`;
            const municipality = isNullOrWhiteSpace(this.model.address.municipality) ? `` : `, ${this.model.address.municipality}`;
            const province = isNullOrWhiteSpace(this.model.address.province) ? `` : `, ${this.model.address.province}`;
            const postalCode = isNullOrWhiteSpace(this.model.address.postalCode) ? `` : `, ${this.model.address.postalCode}`;
            const streetAndHouse = this.model.address.street === this.model.address.houseNumber 
                ? this.model.address.street 
                : `${this.model.address.street} ${this.model.address.houseNumber}`;
            
            return `${streetAndHouse}${flat}${district}${municipality}${province}${postalCode}`;
        }
    }
